import CardTable from 'components/CardTable/CardTable'
import { useOpenComponent } from 'hooks/useOpenComponent'
import React from 'react'
import { useState } from 'react'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import AddIcon from "@material-ui/icons/Add";
import { columns } from './columns'
import Snackbars from "components/Snackbar/Snackbar.js";
import { resetMovementSelected } from 'redux/actions/gasMovements/gasMovActions'
import { addMovementMode } from 'redux/actions/gasMovements/gasMovActions'
import { getMovements } from 'redux/actions/gasMovements/gasMovActions'
import { TrendingUp } from '@material-ui/icons'
import RegularButton from 'components/CustomButtons/Button'
import { ModalV2 } from 'components/Modal/ModalV2'
import { FormGasMovEdit } from './FormGasMovEdit'
import { useSearch } from 'hooks/useSearch'

export const GasMovements = () => {
  const { clearSnackbar } = useSearch();
  const { token } = useSelector(state => state.login)
  const { movementsArr, addMovement} = useSelector(state => state.gasMovements)
  const { color, message, isOpen: isSnackbarOpen, isLoading } = useSelector((state) => state.search)
  const { isOpen, handleIsOpen } = useOpenComponent()
  const [mapData, setMapData] = useState([])
  const dispatch = useDispatch()

  const handleClose = () => {
    dispatch(resetMovementSelected())
    handleIsOpen()
  }
  
  const handleOpenAdd = () => {
    dispatch(addMovementMode())
    handleIsOpen()
  }

  useEffect(() => {
    movementsArr.length === 0 && dispatch(getMovements())
  }, [])

  useEffect(() => {    
    setMapData(
      movementsArr?.map(movement => {
        return {
          ...movement,
          modal: handleIsOpen,
        }
      }).flat()
    )
    // eslint-disable-next-line
  }, [movementsArr])

  return (
    <React.Fragment>
      <CardTable
        data={mapData}
        columns={columns}
        loading={isLoading}
        hasHeader
        title={"Catalogo de Bonificacion de Gas"}
        icon={<TrendingUp/>}
        blockBtn
        hasControl
        controls={
          addMovement && (
            <RegularButton round justIcon color="info" style={{ margin: 10 }} onClick={handleOpenAdd}>
              <AddIcon style={{ margin: 0 }}/>
            </RegularButton>
          )
        }
      />
      <ModalV2
        open={isOpen}
        onClose={handleClose}
        toRight
      >
        <FormGasMovEdit handleClose={handleClose}/>
      </ModalV2>

      <Snackbars
        place="tr"
        color={color}
        message={message}
        open={isSnackbarOpen}
        closeNotification={clearSnackbar}
        close
      /> 
    </React.Fragment>
  )
}
